import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function ProofSection() {
  return <section className="py-24 px-4 bg-dark-900 relative" data-id="element-134">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/5 via-dark-900 to-dark-900 pointer-events-none" data-id="element-135" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-136">
        <FadeIn data-id="element-137">
          <h2 className="text-3xl md:text-4xl mb-12" data-id="element-138">
            Lo que cambia en 7 días
          </h2>

          <div className="text-xl md:text-2xl leading-relaxed text-offwhite/90 font-serif italic space-y-6" data-id="element-139">
            <p data-id="element-140">La presión opresiva en tu pecho disminuye.</p>
            <p data-id="element-141">
              Las notificaciones de tu teléfono ya no disparan un ataque de
              pánico incontrolable.
            </p>
            <p data-id="element-142">
              Empiezas a recordar eventos con claridad, sin la "niebla" mental
              que él impuso.
            </p>
            <p className="text-gold mt-8 font-normal" data-id="element-143">
              Dejas de buscar su aprobación y empiezas, por primera vez en mucho
              tiempo, a buscar tu propia paz.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}